export default {
  FILE: 'file',
  URL:  'url'
};
